import type { PropsWithChildren } from "react";
import { useFormContext } from "react-hook-form";
import { type BaseButtonProps, Button } from "../button";
import { localized } from "../localization";
import { useModalContext } from "./context";
import { ModalFooter } from "./modal-footer";

/** Props Interface */
interface ModalFooterFormProps extends PropsWithChildren {
	isDisabled?: boolean;
	isLoading?: boolean;
	cancelLabel?: string;
	cancelButtonProps?: BaseButtonProps;
	submitLabel?: string;
	submitButtonProps?: BaseButtonProps;
}

export function ModalFooterForm({
	isDisabled = false,
	isLoading = false,
	cancelLabel = localized("general.cancel"),
	cancelButtonProps = {},
	submitLabel = localized("general.submit"),
	submitButtonProps = {},
	children,
}: ModalFooterFormProps) {
	/** Hooks */
	const { onClose } = useModalContext();
	const methods = useFormContext();

	/** Render */
	return (
		<ModalFooter>
			{children}
			<div className="self-end h-stack gap-4 ml-auto">
				<Button
					onClick={onClose}
					variant="ghost"
					{...cancelButtonProps}
				>
					{cancelLabel}
				</Button>
				<Button
					type="submit"
					variant="primary"
					isLoading={methods.formState.isSubmitting || isLoading}
					isDisabled={isDisabled}
					{...submitButtonProps}
				>
					{submitLabel}
				</Button>
			</div>
		</ModalFooter>
	);
}
